import { useMemo } from "react";
import { useFetch } from "../useFetch";
import { PagedResultDto } from "../../types/api/PagedResultDto";
import { ContainerPlatform } from "../../types/api/guide/containerPlatform.types";
import { containerPlatformService } from "../../services/guide/containerPlatform-service";

export const useFetchPagedContainerPlatform = (page: number, pageSize: number, name?: string) => {
    const params = useMemo(() => [page, pageSize, name] as const, [page, pageSize, name]);
    return useFetch<PagedResultDto<ContainerPlatform>>(
        containerPlatformService.getPaged,
        params as unknown as [number, number, string?]
    );
};
